/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
/*$(".FaqSummary__Item").click(function() {
  //alert ('scrollup');
  //jQuery('html,body').animate({scrollTop:250},2000);
});*/
/*******/
$(document).ready(function() {

  
  $( ".ReviewsWidget" ).on( "click", ".ElementsWidget__media .R-MediaSlider__inner .R-RatingStars div[title='5 Stars']", function() {
    $('.ElementsWidget__subheader .R-TabControls__item .R-DropUpDownMenu .R-DropUpDownMenu__inner div[title="5 Stars"]').click();
    $(".ElementsWidget__media .R-MediaSlider__inner .R-RatingStars").removeClass('star_active');
    $(".ElementsWidget__media .R-MediaSlider__inner .R-RatingStars div[title='5 Stars']").closest('.R-RatingStars').addClass('star_active');
  });

  $( ".ReviewsWidget" ).on( "click", ".ElementsWidget__media .R-MediaSlider__inner .R-RatingStars div[title='4 Stars']", function() {
    $('.ElementsWidget__subheader .R-TabControls__item .R-DropUpDownMenu .R-DropUpDownMenu__inner div[title="4 Stars"]').click();
    $(".ElementsWidget__media .R-MediaSlider__inner .R-RatingStars").removeClass('star_active');
    $(".ElementsWidget__media .R-MediaSlider__inner .R-RatingStars div[title='4 Stars']").closest('.R-RatingStars').addClass('star_active');
  });
  $( ".ReviewsWidget" ).on( "click", ".ElementsWidget__media .R-MediaSlider__inner .R-RatingStars div[title='3 Stars']", function() {
    $('.ElementsWidget__subheader .R-TabControls__item .R-DropUpDownMenu .R-DropUpDownMenu__inner div[title="3 Stars"]').click();
    $(".ElementsWidget__media .R-MediaSlider__inner .R-RatingStars").removeClass('star_active');
    $(".ElementsWidget__media .R-MediaSlider__inner .R-RatingStars div[title='3 Stars']").closest('.R-RatingStars').addClass('star_active');
  });
  $( ".ReviewsWidget" ).on( "click", ".ElementsWidget__media .R-MediaSlider__inner .R-RatingStars div[title='2 Stars']", function() {
    $('.ElementsWidget__subheader .R-TabControls__item .R-DropUpDownMenu .R-DropUpDownMenu__inner div[title="2 Stars"]').click();
    $(".ElementsWidget__media .R-MediaSlider__inner .R-RatingStars").removeClass('star_active');
    $(".ElementsWidget__media .R-MediaSlider__inner .R-RatingStars div[title='2 Stars']").closest('.R-RatingStars').addClass('star_active');
  });
  $( ".ReviewsWidget" ).on( "click", ".ElementsWidget__media .R-MediaSlider__inner .R-RatingStars div[title='1 Stars']", function() {
    $('.ElementsWidget__subheader .R-TabControls__item .R-DropUpDownMenu .R-DropUpDownMenu__inner div[title="1 Stars"]').click();
    $(".ElementsWidget__media .R-MediaSlider__inner .R-RatingStars").removeClass('star_active');
    $(".ElementsWidget__media .R-MediaSlider__inner .R-RatingStars div[title='1 Stars']").closest('.R-RatingStars').addClass('star_active');
  });
  $('input#option-product-template-updated-0-0').click(function(){
    $(".produkte_variant_title").html('<div class="yellow_">CLASSIC</div>');
    $(".pdp_varaint_desc_vegan").addClass('pdp_variant_off');
    $(".pdp_varaint_desc_classic").removeClass('pdp_variant_off');
  });

  $('input#option-product-template-updated-0-1').click(function(){
    $(".produkte_variant_title").html('<div class="green_">VEGAN</div>');
    $(".pdp_varaint_desc_classic").addClass('pdp_variant_off');
    $(".pdp_varaint_desc_vegan").removeClass('pdp_variant_off');
  });

  var maxLength = 300;
  //alert('hi');  
  window.setTimeout(function(){


    $(".R-TextBody").each(function(){
      var myStr = $(this).text();
      if($.trim(myStr).length > maxLength){
        // alert('hi');
        var newStr = myStr.substring(0, maxLength);
        var removedStr = myStr.substring(maxLength, $.trim(myStr).length);
        $(this).empty().html(newStr);
        $(this).append('<a href="javascript:void(0);" class="read-more">... Weiterlesen </a>');
        $(this).append('<span class="more-text">' + removedStr + '</span>');
      }
    });

    $(".read-more").click(function(){
      // alert("hii");
      $(this).siblings(".more-text").contents().unwrap();
      $(this).remove();
    });

  }, 2000);

});
/*******/
$(document).ready(function() {
  $('.col_reviews').click(function(){
    jQuery('html, body').animate({
      scrollTop: jQuery('.Section-reviews').offset().top-20
    }, 1000);

  });
  //alert("hii");
  var s = $(".only_for___mobile");
  var nn=$('.payment_icons');
  var pos = nn.position();
  if(pos != null){
    $(window).scroll(function() {
      var windowpos = $(window).scrollTop();
      if (windowpos > pos.top) {
        s.addClass("stick");
        s.show();
      } else {
        s.removeClass("stick");
        s.hide();
      }
    });
  }


  window.setTimeout(function(){

    //var nameauthor=$('.cssVar-authorName').text();
    var thestars= $('.R-TabControls .R-DropUpDownMenu__inner .u-marginBottom--sm:last-child').html();
    //  $('.item__review .R-TextHeading.R-TextHeading--xxs.u-textLeft--all').html(nameauthor);
    //alert(thestars);
    $('.R-MediaSlider__inner').html(thestars);

  }, 2000);

  //alert("hii");
  /*  data = {};
                $.ajax({
                    type: 'GET',
                    url: 'https://api.reviews.co.uk/timeline/data?type=product_review&store=slimbox',
                    data: data,
                    dataType: 'json',
                    success: function(data) { 
                     // alert("hello");
                        console.log(data);
                        $.each( data, function(i, item) {
                             console.log(item);
                            // do something with your data here
                        });
                    }
                });*/
});

$('.Faq__Icon').click(function(){
  $(this).next().find('button').trigger('click');
});
/* $('body').click(function(){
  $('.ElementsWidget__form.isActive').css('opacity','0');
 });*/